export const MAX_FILE_SIZE: number = 104857600; //100MB
export const AGENT_ACCEPTED_FILE_TYPES: string[] = ['.pdf', 'image/*'];
export const AGENT_MAX_FILE_SIZE: number = 5242880; //5MB
